"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var getPronounsLabel = function getPronounsLabel(pronouns) {
  if ((0, _isEmpty.default)(pronouns)) {
    return '';
  }
  return Object.keys(pronouns).filter(function (key) {
    return pronouns[key];
  }).map(function (key) {
    return pronouns[key];
  }).join(', ');
};
var _default = getPronounsLabel;
exports.default = _default;